import { useEffect } from 'react'

type ColorGroup = {
  group: string[]
  blockClass: string
}

const colorGroups: ColorGroup[] = [
  { group: ['.heading-turquoise', '.preamble-turquoise', '.list-turquoise'], blockClass: 'turquoise-block' },
  { group: ['.heading-blue', '.preamble-blue', '.list-blue'], blockClass: 'blue-block' },
  { group: ['.heading-pink', '.preamble-pink', '.list-pink'], blockClass: 'pink-block' },
  { group: ['.heading-orange', '.preamble-orange', '.list-orange'], blockClass: 'orange-block' },
  { group: ['.heading-purple', '.preamble-purple', '.list-purple'], blockClass: 'purple-block' },
  { group: ['.heading-green', '.preamble-green', '.list-green'], blockClass: 'green-block' },
]

const useTagElements = (doc: HTMLDivElement | null) => {
  useEffect(() => {
    if (!doc) return

    colorGroups.forEach((colorGroup) => {
      const elements = Array.from(doc.querySelectorAll(colorGroup.group.join(',')))
      elements[0]
      elements.forEach(addWrapperDiv(colorGroup))
    })
  }, [doc])
}

const addWrapperDiv =
  ({ group, blockClass }: ColorGroup) =>
  (el: Element) => {
    if (el.closest(`.${blockClass}`) !== null) return // Skip if already wrapped

    const groupElements = [el]

    let nextEl = el.nextElementSibling

    while (
      nextEl instanceof HTMLElement &&
      (group.some((className) => nextEl!.matches(className)) || nextEl.tagName.toLowerCase() === 'table')
    ) {
      groupElements.push(nextEl)
      nextEl = nextEl.nextElementSibling
    }

    const blockEl = document.createElement('div')
    blockEl.className = blockClass

    const parentEl = groupElements[0].parentElement

    if (!parentEl) return

    parentEl.insertBefore(blockEl, groupElements[0])
    groupElements.forEach((el) => blockEl.appendChild(el))
  }

export default useTagElements
